export default "__VITE_PUBLIC_ASSET__08a67209__"